import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, CheckCircle2, Headphones, Gift, ChevronDown, ChevronUp, Tag, BookOpen, Sparkles, AlertTriangle } from 'lucide-react';
import { trackEvent } from '../utils/fbpixel';
export function PricingCTA() {
  const [showBonosDetails, setShowBonosDetails] = useState(false);
  const [showBundleBonosDetails, setShowBundleBonosDetails] = useState(false);
  return <section id="pricing" className="py-16 px-4 bg-matrix-bg relative overflow-hidden" data-id="element-130">
      {/* Background glow behind pricing */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-matrix-primary/5 blur-[100px] rounded-full pointer-events-none" data-id="element-131" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-133">
          <h2 className="text-3xl md:text-5xl font-black text-matrix-orange mb-8" data-id="element-134">
            Tu primera decisión
            <br data-id="element-135" />
            <span className="text-matrix-muted text-2xl md:text-3xl font-normal" data-id="element-136">
              (la que cambia todo)
            </span>
          </h2>

          <div className="space-y-6 text-xl text-matrix-muted mb-12" data-id="element-137">
            <p data-id="element-138">No es comprar.</p>
            <p data-id="element-139">
              Es elegir un{' '}
              <span className="text-matrix-orange font-semibold" data-id="element-140">umbral</span>.
            </p>
            <p data-id="element-141">Cama. Mesa. Baño. Escritorio.</p>
            <p className="font-bold text-matrix-text" data-id="element-142">Uno.</p>
            <p className="text-2xl md:text-3xl text-matrix-primary font-bold pt-4 text-glow" data-id="element-143">
              Cuando proteges un umbral, dejas de vivir como invitado en tu
              mente.
            </p>
          </div>

          {/* Danger statement */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center gap-3 mb-12 px-2" data-id="element-144">
            {/* Danger icon */}
            <motion.div animate={{
            rotate: [-10, 10, -10],
            scale: [1, 1.15, 1]
          }} transition={{
            duration: 0.4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} style={{
            filter: 'drop-shadow(0 0 12px rgba(255,26,26,0.9))'
          }} data-id="element-145"></motion.div>

            {/* Danger text — scale-pulse "coming at you" */}
            <motion.p animate={{
            scale: [1, 1.05, 1],
            textShadow: ['0 0 10px rgba(255,26,26,0.4), 0 0 20px rgba(255,26,26,0.2)', '0 0 25px rgba(255,26,26,0.95), 0 0 50px rgba(255,26,26,0.6)', '0 0 10px rgba(255,26,26,0.4), 0 0 20px rgba(255,26,26,0.2)']
          }} transition={{
            duration: 0.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="text-2xl md:text-4xl font-black uppercase text-center leading-tight tracking-wide" style={{
            color: '#ff1a1a'
          }} data-id="element-146">
              ESTO ES SOLO PARA PERSONAS QUE SE SIENTEN ROTAS FÍSICA Y
              ESPIRITUALMENTE Y NO ENCUENTRAN EL CAMINO
            </motion.p>
          </motion.div>

          {/* Pricing Card 1 - Standard (Unchanged) */}
          <div className="bg-matrix-surface border border-matrix-primary/30 p-10 rounded-xl max-w-md mx-auto shadow-[0_0_30px_rgba(0,255,65,0.1)] relative overflow-hidden" data-id="element-147">
            {/* OFERTA LIMITADA tag */}
            <div className="absolute top-4 right-[-34px] z-20 rotate-45 bg-matrix-red px-10 py-1 shadow-lg" data-id="element-148">
              <span className="text-white text-[10px] font-black uppercase tracking-wider flex items-center gap-1" data-id="element-149">
                OFERTA LIMITADA
              </span>
            </div>

            {/* Product Cover Image */}
            <div className="mb-6 -mx-4 -mt-4" data-id="element-150">
              <div className="relative" data-id="element-151">
                <div className="absolute inset-0 bg-matrix-primary/10 blur-2xl rounded-full transform scale-75 pointer-events-none" data-id="element-152" />
                <img src="https://cdn.magicpatterns.com/uploads/cbbzLVk6tr3sGcabEnHxQ4/heylloyd-image-1771185157620.png" alt="Mente Maestra — Protocolo Anti-Matrix: Audiolibro, Libro Digital, Workbook, Plan Anti-Abandono" className="relative z-10 w-full h-auto rounded-lg" data-id="element-153" />
              </div>
            </div>

            <div className="mb-6" data-id="element-154">
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-155">
                <span className="text-2xl text-matrix-muted line-through font-medium" data-id="element-156">
                  $35
                </span>
                <span className="bg-matrix-red/90 text-white text-xs font-black px-2 py-0.5 rounded" data-id="element-157">
                  74% OFF
                </span>
              </div>
              <span className="text-6xl font-black text-matrix-primary tracking-tight" data-id="element-158">
                $8.89
              </span>
              <p className="text-matrix-muted mt-2" data-id="element-159">Todo incluido</p>
            </div>

            {/* What's included checklist */}
            <div className="text-left mb-8 bg-matrix-red/5 border border-matrix-red/30 rounded-lg p-4 relative" data-id="element-160">
              <p className="text-matrix-red text-xs font-black uppercase tracking-widest mb-3 flex items-center gap-2" data-id="element-161">
                TODO ESTO INCLUIDO POR $8.89:
              </p>
              <div className="space-y-3" data-id="element-162">
                {['Audiobook completo (1 hora, 14 tracks)', 'PDF Libro Digital', 'Libro de Trabajo + Tracker 30 días', 'Plan Anti-Abandono'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-163">
                    <CheckCircle2 className="w-5 h-5 text-matrix-red shrink-0" data-id="element-164" />
                    <span className="text-matrix-text text-sm font-bold" data-id="element-165">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Mini Bonos Section */}
            <div className="mb-6 bg-matrix-bg/50 border border-matrix-orange/20 rounded-lg overflow-hidden text-left" data-id="element-166">
              <div className="p-4 border-b border-matrix-orange/10 bg-matrix-orange/5" data-id="element-167">
                <div className="flex items-center gap-2 mb-3" data-id="element-168">
                  <Gift className="w-4 h-4 text-matrix-orange" data-id="element-169" />
                  <p className="text-matrix-orange text-xs font-bold uppercase tracking-wide" data-id="element-170">
                    Bonos incluidos GRATIS (Valor $110):
                  </p>
                </div>
                <div className="space-y-3" data-id="element-171">
                  <div className="flex items-center gap-3" data-id="element-172">
                    <img src="https://cdn.magicpatterns.com/uploads/tWATLzc47etq2YS2oBkeMH/workbook.png" alt="Workbook + Tracker" className="w-12 h-12 rounded object-cover border border-matrix-primary/20 shrink-0" data-id="element-173" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-174">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-175">
                        <CheckCircle2 className="w-3 h-3 text-matrix-primary" data-id="element-176" />{' '}
                        Libro de Trabajo + Tracker
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-177">
                        $39
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-178">
                    <img src="https://cdn.magicpatterns.com/uploads/gFwfkgkMbQ5ozoQ7BAcT2r/libro_digital_version.png" alt="Libro Digital" className="w-12 h-12 rounded object-cover border border-matrix-primary/20 shrink-0" data-id="element-179" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-180">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-181">
                        <CheckCircle2 className="w-3 h-3 text-matrix-primary" data-id="element-182" />{' '}
                        Libro Digital
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-183">
                        $34
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-184">
                    <img src="https://cdn.magicpatterns.com/uploads/4Zt9ph4j8HA12xsA9DFKGx/bonos2.png" alt="Plan Anti-Abandono" className="w-12 h-12 rounded object-cover border border-matrix-primary/20 shrink-0" data-id="element-185" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-186">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-187">
                        <CheckCircle2 className="w-3 h-3 text-matrix-primary" data-id="element-188" />{' '}
                        Plan Anti-Abandono
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-189">
                        $37
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Mini Audio Preview */}
            <div className="mb-6 bg-matrix-bg/80 border border-matrix-primary/20 rounded-lg overflow-hidden" data-id="element-190">
              <div className="flex items-center gap-2 px-3 py-2 border-b border-matrix-primary/10" data-id="element-191">
                <Headphones className="w-3.5 h-3.5 text-matrix-primary" data-id="element-192" />
                <p className="text-matrix-primary text-[10px] font-matrix tracking-widest uppercase" data-id="element-193">
                  {'>'} Escucha antes de comprar
                </p>
              </div>
              <div className="w-full bg-black/60 relative" style={{
              height: '60px'
            }} data-id="element-194">
                <iframe src="https://drive.google.com/file/d/18AUXVOyaI_9Xa9voIR8bSz3tjIrE0WU2/preview" width="100%" height="60" allow="autoplay" style={{
                border: 'none'
              }} title="Mente Maestra - Preview" data-id="element-195" />
                <div className="absolute top-0 right-0 w-12 h-12 bg-matrix-bg pointer-events-auto z-10" data-id="element-196" />
              </div>
            </div>

            <motion.a href="https://www.mellowreset.com/cart/42986204659778:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            trackEvent('InitiateCheckout', {
              content_name: 'Mente Maestra',
              content_ids: ['42986204659778'],
              content_type: 'product',
              value: 17.89,
              currency: 'USD'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full py-4 text-matrix-bg font-bold text-xl rounded-sm hover:bg-matrix-secondary transition-colors shadow-[0_0_20px_rgba(0,255,65,0.4)] animate-pulse-glow flex items-center justify-center gap-2 bg-[#00ff41]" data-id="element-197">
              Comprar Ahora
            </motion.a>

            <p className="text-matrix-text font-medium" data-id="element-198">
              Empieza con el Track 1 hoy.
            </p>
          </div>

          {/* Divider between cards */}
          <div className="flex items-center gap-4 my-10 max-w-md mx-auto" data-id="element-199">
            <div className="flex-1 h-px bg-matrix-primary/20" data-id="element-200" />
            <span className="text-matrix-orange text-sm font-bold uppercase tracking-widest" data-id="element-201">
              ó
            </span>
            <div className="flex-1 h-px bg-matrix-primary/20" data-id="element-202" />
          </div>

          {/* Second Pricing Card - Bundle Completo (MODIFIED) */}
          <div className="bg-matrix-surface border border-[#00d4ff]/40 p-10 rounded-xl max-w-md mx-auto shadow-[0_0_30px_rgba(0,212,255,0.1)] relative overflow-hidden" data-id="element-203">
            {/* MÁS POPULAR tag - KEEP ORANGE */}
            <div className="absolute top-4 right-[-30px] z-20 rotate-45 bg-matrix-orange px-10 py-1 shadow-lg" data-id="element-204">
              <span className="text-matrix-bg text-[10px] font-black uppercase tracking-wider flex items-center gap-1" data-id="element-205">
                MÁS POPULAR
              </span>
            </div>

            {/* Product Cover Image - $17.89 card */}
            <div className="mb-6 -mx-4 -mt-4" data-id="element-206">
              <div className="relative" data-id="element-207">
                <div className="absolute inset-0 bg-[#00d4ff]/10 blur-2xl rounded-full transform scale-75 pointer-events-none" data-id="element-208" />
                <img src="https://cdn.magicpatterns.com/uploads/rX1xLj6Vi9Nnu2bkQ6KJ4r/heylloyd-image-1771109728119.png" alt="Bundle Completo — Mente Maestra + Meditaciones Espirituales de Dios" className="relative z-10 w-full h-auto rounded-lg" data-id="element-209" />
              </div>
            </div>

            <div className="mb-6" data-id="element-210">
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-211">
                <span className="text-2xl text-matrix-muted line-through font-medium" data-id="element-212">
                  $60
                </span>
                <span className="text-white text-xs font-black px-2 py-0.5 rounded bg-[#6600ff]" data-id="element-213">
                  75% OFF
                </span>
              </div>
              <span className="text-6xl font-black tracking-tight text-[#f31212] bg-[#000000]" data-id="element-214">
                $14.89
              </span>
              <p className="text-matrix-muted mt-2" data-id="element-215">Kit Completo</p>
            </div>

            {/* What's included checklist - GREEN THEME */}
            <div className="text-left mb-8 bg-green-500/5 border border-green-500/30 rounded-lg p-4 relative" data-id="element-216">
              <p className="text-green-400 text-xs font-black uppercase tracking-widest mb-3 flex items-center gap-2" data-id="element-217">
                TODO ESTO INCLUIDO POR $14.89:
              </p>
              <div className="space-y-3" data-id="element-218">
                {['Mente Maestra — Audiobook (1 hora, 14 tracks)', 'Mente Maestra — PDF Libro Digital', 'Meditaciones Espirituales de Dios (Audio)', 'Meditaciones Espirituales de Dios — Libro Digital', 'Libro de Trabajo + Tracker 30 días', 'Plan Anti-Abandono', '+ 5 Bonos adicionales'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-219">
                    <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-220" />
                    <span className="text-matrix-text text-sm font-bold" data-id="element-221">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* NEW SECTION A: Bonos (Tiny) */}
            <div className="mb-6 bg-matrix-bg/50 border border-matrix-orange/20 rounded-lg overflow-hidden text-left" data-id="element-222">
              <div className="p-4 border-b border-matrix-orange/10 bg-matrix-orange/5" data-id="element-223">
                <div className="flex items-center gap-2 mb-3" data-id="element-224">
                  <Gift className="w-4 h-4 text-matrix-orange" data-id="element-225" />
                  <p className="text-matrix-orange text-xs font-bold uppercase tracking-wide" data-id="element-226">
                    5 Bonos incluidos GRATIS (Valor $179):
                  </p>
                </div>
                <div className="space-y-3" data-id="element-227">
                  <div className="flex items-center gap-3" data-id="element-228">
                    <img src="https://cdn.magicpatterns.com/uploads/hVecLDs5bg3Q35Z84iZiwk/bonos1.png" alt="Frases de Poder Anti-Matrix" className="w-12 h-12 rounded object-cover border border-matrix-orange/20 shrink-0" data-id="element-229" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-230">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-231">
                        <CheckCircle2 className="w-3 h-3 text-matrix-orange" data-id="element-232" />{' '}
                        Frases de Poder Anti-Matrix
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-233">
                        $29
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-234">
                    <img src="https://cdn.magicpatterns.com/uploads/fYSfbR3nGmTLsepyq2cRW2/bonos2.png" alt="Plan Anti-Abandono" className="w-12 h-12 rounded object-cover border border-matrix-orange/20 shrink-0" data-id="element-235" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-236">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-237">
                        <CheckCircle2 className="w-3 h-3 text-matrix-orange" data-id="element-238" />{' '}
                        Plan Anti-Abandono
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-239">
                        $37
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-240">
                    <img src="https://cdn.magicpatterns.com/uploads/bwVb1FR3pd6cZ5m7hoi8JU/bonos3.png" alt="Biblioteca de Señales" className="w-12 h-12 rounded object-cover border border-matrix-orange/20 shrink-0" data-id="element-241" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-242">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-243">
                        <CheckCircle2 className="w-3 h-3 text-matrix-orange" data-id="element-244" />{' '}
                        Biblioteca de Señales
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-245">
                        $39
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-246">
                    <img src="https://cdn.magicpatterns.com/uploads/aZyZHDPhRpRqHJLuPWq5p2/bonos4.png" alt="Rutinas Mañana / Tarde / Noche" className="w-12 h-12 rounded object-cover border border-matrix-orange/20 shrink-0" data-id="element-247" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-248">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-249">
                        <CheckCircle2 className="w-3 h-3 text-matrix-orange" data-id="element-250" />{' '}
                        Rutinas Mañana / Tarde / Noche
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-251">
                        $35
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-252">
                    <img src="https://cdn.magicpatterns.com/uploads/qXvni48sma1K7TXRbiBczB/bonos5.png" alt="Tablero de Control" className="w-12 h-12 rounded object-cover border border-matrix-orange/20 shrink-0" data-id="element-253" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-254">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-255">
                        <CheckCircle2 className="w-3 h-3 text-matrix-orange" data-id="element-256" />{' '}
                        Tablero de Control
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-257">
                        $39
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* NEW SECTION B: Meditaciones Espirituales de Dios */}
            <div className="mb-8 bg-matrix-surface border border-[#00d4ff]/30 rounded-lg overflow-hidden text-left relative" data-id="element-258">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00d4ff]/20 via-[#00d4ff] to-[#00d4ff]/20" data-id="element-259" />

              {/* Large product image */}
              <div className="relative" data-id="element-260">
                <div className="absolute inset-0 bg-[#00d4ff]/10 blur-2xl rounded-full transform scale-75 pointer-events-none" data-id="element-261" />
                <p className="text-center text-[#00d4ff] font-black text-xl md:text-2xl uppercase tracking-wide pt-4 px-4 relative z-10" style={{
                textShadow: '0 0 20px rgba(0,212,255,0.5)'
              }} data-id="element-262">
                  ESTO CAMBIARÁ TU VIDA TOTALMENTE!
                </p>
                <img src="https://cdn.magicpatterns.com/uploads/ke7jLrCbNT6DAtFEqEuFs9/private_openrouter-generated-image-1771187146158.png" alt="Meditaciones Espirituales de Dios — Audio y Libro Digital" className="relative z-10 w-full h-auto" data-id="element-263" />
              </div>

              <div className="p-4" data-id="element-264">
                <div className="mb-4" data-id="element-265">
                  <h4 className="text-[#00d4ff] font-bold mb-1 text-[20px]" data-id="element-266">
                    MEDITACIONES ESPIRITUALES DE DIOS
                  </h4>
                  <p className="text-[16px] text-[#1eff00]" data-id="element-267">
                    (Audio y Libro Digital)
                  </p>
                </div>

                <div className="space-y-3 text-xs text-matrix-text/90" data-id="element-268">
                  <p className="italic text-matrix-muted border-l-2 border-[#00d4ff]/40 pl-2 text-[14px]" data-id="element-269">
                    "Si tu mente no se calla… tu cuerpo no descansa… y tu
                    corazón se siente cargado."
                  </p>

                  <p className="text-[14px]" data-id="element-270">
                    Una colección de meditaciones guiadas con enfoque cristiano,
                    diseñadas para:
                  </p>

                  <ul className="space-y-1.5 pl-1" data-id="element-271">
                    <li className="flex items-start gap-2" data-id="element-272">
                      <Sparkles className="w-3 h-3 text-[#00d4ff] mt-0.5 shrink-0" data-id="element-273" />
                      <span className="text-[14px]" data-id="element-274">
                        Calmar la mente sin desconectarte de tu fe
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-275">
                      <Sparkles className="w-3 h-3 text-[#00d4ff] mt-0.5 shrink-0" data-id="element-276" />
                      <span className="text-[14px]" data-id="element-277">
                        Llevar tu ansiedad a la Presencia de Dios
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-278">
                      <Sparkles className="w-3 h-3 text-[#00d4ff] mt-0.5 shrink-0" data-id="element-279" />
                      <span className="text-[14px]" data-id="element-280">
                        Entrenar tu interior a responder con paz
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-281">
                      <Sparkles className="w-3 h-3 text-[#00d4ff] mt-0.5 shrink-0" data-id="element-282" />
                      <span className="text-[14px]" data-id="element-283">
                        Dormir mejor y cerrar el día con descanso
                      </span>
                    </li>
                  </ul>

                  <div className="bg-[#00d4ff]/10 p-2 rounded border border-[#00d4ff]/20 mt-2" data-id="element-284">
                    <p className="text-[#00d4ff] font-medium text-center text-[14px]" data-id="element-285">
                      No necesitas más información. Necesitas una práctica
                      diaria de regreso a Dios.
                    </p>
                  </div>

                  {/* Audio Preview — Meditaciones Espirituales de Dios */}
                  <div className="mt-4 bg-black/40 border border-[#00d4ff]/25 rounded-lg overflow-hidden" data-id="element-286">
                    <div className="flex items-center gap-2 px-3 py-2 border-b border-[#00d4ff]/15 bg-[#00d4ff]/5" data-id="element-287">
                      <Headphones className="w-3.5 h-3.5 text-[#00d4ff]" data-id="element-288" />
                      <p className="text-[#00d4ff] text-[10px] font-matrix tracking-widest uppercase" data-id="element-289">
                        {'>'} Escucha una muestra de las meditaciones
                      </p>
                    </div>
                    {/* Decorative waveform */}
                    <div className="flex items-end justify-center gap-[2px] px-4 pt-2 pb-0 h-6" data-id="element-290">
                      {Array.from({
                      length: 36
                    }).map((_, i) => {
                      const h = Math.sin(i * 0.4) * 0.5 + 0.5;
                      return <div key={i} className="w-[2px] rounded-full bg-[#00d4ff]/30 animate-pulse" style={{
                        height: `${Math.max(h * 100, 20)}%`,
                        animationDelay: `${i * 80}ms`,
                        animationDuration: '2s'
                      }} data-id="element-291" />;
                    })}
                    </div>
                    <div className="w-full bg-black/60 relative" style={{
                    height: '60px'
                  }} data-id="element-292">
                      <iframe src="https://drive.google.com/file/d/1NIcuy1P1qBQgqbIz_mKDEXXfWwoQl2GI/preview" width="100%" height="60" allow="autoplay" style={{
                      border: 'none'
                    }} title="Meditaciones Espirituales de Dios - Preview" data-id="element-293" />
                      <div className="absolute top-0 right-0 w-12 h-12 bg-matrix-bg pointer-events-auto z-10" data-id="element-294" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <motion.a href="https://www.mellowreset.com/cart/43001376145474:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            trackEvent('InitiateCheckout', {
              content_name: 'Bundle Completo',
              content_ids: ['43001376145474'],
              content_type: 'product',
              value: 17.89,
              currency: 'USD'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full py-4 text-matrix-bg font-bold text-xl rounded-sm hover:bg-[#00d4ff]/80 transition-colors shadow-[0_0_20px_rgba(0,212,255,0.4)] animate-pulse-glow flex items-center justify-center gap-2 bg-[#00ff41]" data-id="element-295">
              Comprar Ahora
            </motion.a>

            <p className="text-matrix-text font-medium" data-id="element-296">
              Todo lo que necesitas para tu reset total.
            </p>
          </div>

          <p className="mt-12 text-matrix-muted italic" data-id="element-297">
            no estás buscando perfección. Estás entrenando regreso.
          </p>
        </motion.div>
      </div>
    </section>;
}